module.exports = __webpack_public_path__ + "static/busbiker-new-a7aace3887a820419df0fab8a0d412ff.png";